import { render, staticRenderFns } from "./OrganizationProfileForm.vue?vue&type=template&id=04f09dbb&"
import script from "./OrganizationProfileForm.vue?vue&type=script&lang=ts&"
export * from "./OrganizationProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationProfileForm.vue?vue&type=style&index=0&id=04f09dbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports